import React from 'react';

import CaretIcon from '@hero/ui-kit/icons/utility/CaretIcon';
import Button from '@hero/ui-kit/inputs/Button';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import P from '@hero/ui-kit/typography/P';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuNavbar from '../../../../components/Layout/MenuNavbar';
import Pill from '../../../LeadsManagement/components/Pill';
import { OrganizationMemberDetails } from '../../types';
import { useOrganizationMemberDetailsContext } from '../context/OrganizationMemberDetailsContext';
import { getMemberListBackTo } from '../MemberDetailsWrapper/useMemberListNeighbors';
import UserInfo from '../MemberDetailsWrapper/UserInfo';

interface GeneralStickyNavbarProps {
    member?: OrganizationMemberDetails;
    showStickyNavbar?: boolean;
    isChanged?: boolean;
    isLoading?: boolean;
}

const StickyNavbar: React.FC<GeneralStickyNavbarProps> = ({
    member,
    isChanged = false,
    isLoading,
    showStickyNavbar
}) => {
    const { currentDevice, memberName } = useOrganizationMemberDetailsContext();
    const navigate = useNavigate();
    const location = useLocation();

    const handleBack = () => {
        navigate(getMemberListBackTo(location.state));
    };

    const isAdmin = currentDevice?.member_role === 'PRIMARY_USER_ADMIN';

    const isDischarged = !!member?.member_info.status_info?.discharged_at;
    const isCancelled = member?.member_info.status_info?.status === 'CANCELLED';

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: '0',
                width: '100%',
                background: 'rgba(255, 255, 255, 1)',
                minHeight: showStickyNavbar ? '60px' : '48px',
                zIndex: 10,
                opacity: showStickyNavbar ? 1 : 0,
                transition: 'all .2s ease-in-out',
                borderBottom: '1px solid rgba(231, 231, 231, 1)',
                boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.16)'
            }}
        >
            <div
                style={{
                    minHeight: showStickyNavbar ? '60px' : '48px',
                    margin: '0 2.4rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        visibility: showStickyNavbar ? 'visible' : 'hidden'
                    }}
                >
                    <MenuNavbar hideLogo />

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: 'calc(var(--gutter) / 2)'
                        }}
                    >
                        <ClickableOpacity onClick={handleBack} alt="Back to form fills">
                            <CaretIcon direction="backward" width={20} height={20} />
                        </ClickableOpacity>

                        <div>
                            <P noDefaultMargin strong styles={{ fontSize: '1.8rem' }}>
                                {memberName}
                            </P>

                            {isDischarged || isCancelled ? <>(Discharged)</> : ''}
                        </div>

                        <Pill
                            label={isAdmin ? 'Admin' : 'Read only'}
                            styles={{
                                padding: 'calc(var(--gutter) / 4) calc(var(--gutter) / 2)',
                                marginRight: 'var(--gutter)',
                                textTransform: 'none',
                                fontWeight: '700',
                                fontSize: '1.6rem',
                                borderRadius: '0.8rem',
                                background: 'rgba(244, 244, 244, 1)'
                            }}
                        />
                    </div>

                    <UserInfo />
                </div>
                {isChanged ? (
                    <div>
                        <Button
                            noDefaultMargin
                            type="submit"
                            disabled={isLoading}
                            styles={{ lineHeight: '3.6rem' }}
                        >
                            Save
                        </Button>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default StickyNavbar;
